import { render, staticRenderFns } from "./WBReferenceCell.vue?vue&type=template&id=4507f604&"
import script from "./WBReferenceCell.vue?vue&type=script&lang=js&"
export * from "./WBReferenceCell.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports